import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DrawerHeader from './DrawerHeader';
import DrawerBody from './DrawerBody';
import DrawerFooter from './DrawerFooter';

function Drawer(props) {
  const {
    type,
    size,
    show,
    onClose,
    children,
    icon,
    className,
  } = props;

  // Clone children and pass size and type as props
  const childrenWithProps = React.Children.map(children, child => {
    if (child.type === DrawerHeader) {
      return cloneElement(child, {
        size,
        type,
        onClose,
        icon,
      });
    }
    if (child.type === DrawerBody) {
      return cloneElement(child);
    }
    if (child.type === DrawerFooter) {
      return cloneElement(child, { onClose });
    }
    return child;
  });

  return (
    <div className={classNames('pgn__drawer', { 'drawer-open': show }, className)}>
      <div className="pgn__drawer-container">
        {childrenWithProps}
      </div>
    </div>
  );
}

Drawer.propTypes = {
  type: PropTypes.oneOf(['basic', 'leftIcon']),
  size: PropTypes.oneOf(['sm', 'lg']),
  show: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  icon: PropTypes.string,
  className: PropTypes.string,
};

Drawer.defaultProps = {
  type: 'right',
  size: 'sm',
  show: false,
  onClose: () => { },
  children: null,
  icon: 'default-icon',
  className: '',
};

Drawer.Header = DrawerHeader;
Drawer.Body = DrawerBody;
Drawer.Footer = DrawerFooter;

export default Drawer;
